import { Icon as CroplerIcon } from '@cropler/ui-kit';

type Props = {
  seconds: number;
};

/**
 * < 1h - no drops,
 * 1-2h - 1 drop,
 * 2-4h - 2 drops,
 * > 4h - 3 drops
 */
const DewIntensityIcon = ({ seconds }: Props) => {
  if (seconds > 14400) return <CroplerIcon name="drop3" width={13} height={14} />;
  if (seconds > 7199) return <CroplerIcon name="drop2" width={8} height={13} />;
  if (seconds > 3599) return <CroplerIcon name="drop" width={7} height={9} />;
  return null;
};

export default DewIntensityIcon;

